import React, { useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { Button } from '@brighterion/br-ui';
import { shouldShowBulkUploads } from 'Selectors';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { RoleService } from 'Services';
import styles from './Header.css';
import AddMerchantModal from '../AddMerchantModal';

const Header = () => {
    const { path } = useRouteMatch();
    const { t } = useTranslation();
    const history = useHistory();
    const [addMerchantModalOpen, setAddMerchantModalOpen] = useState(false);

    const redirectToBulkUpload = () => {
        history.push(`${path}/bulk-upload`);
    };

    const addMerchant = () => {
        setAddMerchantModalOpen(true);
    };

    return (
        <div className={styles.globalRulesHeader}>
            <div className={styles.leftContainer}>
                <div data-testid='overrides-page-title' className={styles.titleText}>
                    {t('Merchants')}
                </div>
            </div>
            {RoleService.hasEditRuleOrBulkUploadAccess && (
                <div className={styles.rightContainer}>
                    {shouldShowBulkUploads() && (
                        <>
                            <Button
                                variant='tertiary'
                                iconName='upload'
                                onClick={handleOnClickEvent(redirectToBulkUpload)}
                                onKeyDown={handleKeyEvent(redirectToBulkUpload)}
                                className={styles.bulkUploadBtn}
                            >
                                {t('Upload Merchant Overrides')}
                            </Button>
                            <hr className={styles.separator} />
                        </>
                    )}
                    <span className={styles.addMerchantBtn}>
                        <Button
                            variant='secondary'
                            size='small'
                            onClick={handleOnClickEvent(addMerchant)}
                            onKeyDown={handleKeyEvent(addMerchant)}
                        >
                            {t('Add Merchant')}
                        </Button>
                    </span>
                </div>
            )}
            <AddMerchantModal isOpen={addMerchantModalOpen} closeModal={() => setAddMerchantModalOpen(false)} />
        </div>
    );
};

export default Header;
